/**
 * Cartão de Livro — ficha 703 do sistema Acervo.
 * Dobra de canto real (não card arredondado genérico) e sombra
 * assimétrica de "livro erguido" no hover, em vez de elevação plana.
 */
import { cn } from '@/lib/utils';

const FALLBACK_GRADIENTS = [
  'from-[#ffd9dd] to-[#f7dde5]',
  'from-[#ffe8d9] to-[#ffd9dd]',
  'from-[#e9e3ff] to-[#f7dde5]',
];

function gradientFor(title) {
  const index = title
    .split('')
    .reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return FALLBACK_GRADIENTS[index % FALLBACK_GRADIENTS.length];
}

export default function BookCard({
  title,
  author,
  tag,
  coverImage,
  size = 'default',
  onClick,
  className,
}) {
  const isCompact = size === 'compact';

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn('group text-left', isCompact ? 'w-28' : 'w-44', className)}
    >
      <div
        className={cn(
          'relative aspect-[2/3] overflow-hidden rounded-[6px_6px_3px_3px]',
          'shadow-sm transition-transform duration-300 ease-out',
          'group-hover:-translate-y-1.5 group-hover:shadow-[-8px_16px_28px_-8px_rgba(64,0,19,0.3)]',
        )}
      >
        {coverImage ? (
          <img
            src={coverImage}
            alt={`Capa de ${title}`}
            className="h-full w-full object-cover"
          />
        ) : (
          <div
            className={cn(
              'flex h-full w-full items-end bg-gradient-to-br p-3',
              gradientFor(title),
            )}
          >
            <span className="font-serif text-wine-deep leading-tight text-base">
              {title}
            </span>
          </div>
        )}

        {/* Dobra de canto — página virada, não decoração solta */}
        <div
          className="absolute right-0 top-0 h-6 w-6 bg-gradient-to-br from-paper-warm to-paper-warm shadow-[-2px_2px_5px_rgba(64,0,19,0.18)]"
          style={{ clipPath: 'polygon(0 0, 100% 0, 100% 100%)' }}
          aria-hidden="true"
        />
      </div>

      <div className="mt-2.5">
        <p
          className={cn(
            'font-semibold leading-tight text-ink',
            isCompact ? 'text-xs' : 'text-sm',
          )}
        >
          {title}
        </p>
        {author && <p className="mt-0.5 text-xs text-graphite">{author}</p>}
        {tag && (
          <p className="mt-1 text-[11px] uppercase tracking-wide text-wine">
            {tag}
          </p>
        )}
      </div>
    </button>
  );
}
